import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d5fa8a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status-grid" }
const _hoisted_2 = { class: "status-grid" }

import { translate } from '@/i18n';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonTitle,
  IonToolbar,
  modalController,
} from '@ionic/vue';
import { closeOutline } from 'ionicons/icons';
import { ref } from 'vue';
import { DateTime } from 'luxon';


export default /*#__PURE__*/_defineComponent({
  props: ["response","returnMap"],
  setup(__props) {

const props = __props



const loopReturnStatus = ref(props.response.returnStatusDetailMap[props.returnMap.loopReturnId] || []);
function formatToLocalDateTime(timestamp: number) {
  if (!timestamp) return '';
  return DateTime
    .fromMillis(timestamp)
    .toLocal()
    .toFormat('MM-dd-yyyy hh:mm a');
}

const cancel = () => modalController.dismiss(null, 'cancel');

return (_ctx: any,_cache: any) => {
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Return Status History")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Loop Return Id")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonLabel), { slot: "end" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.returnMap.loopReturnId), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_unref(translate)("Status")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_unref(translate)("Date")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_unref(translate)("Change Reason")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loopReturnStatus.value, (item, i) => {
              return (_openBlock(), _createBlock(_unref(IonItem), { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.status), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatToLocalDateTime(item.statusDatetime)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.message ? item.message : ''), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})